import {DateTime} from 'luxon';
import {DateTimeOptions} from 'luxon/src/datetime';
import i18n from 'i18n';


const isoTimeToLocal = (
    isoStr: string | null,
    showSeconds: boolean = false,
    datetimeFormat: string | null = null,
    datetimeOpts: DateTimeOptions = {},
): string => {
    if (isoStr === null) {
        return i18n.t('dt_never.text');
    }

    if (datetimeFormat) {
        return `${DateTime.fromISO(isoStr, datetimeOpts).toFormat(datetimeFormat)}`;
    }

    const timestamp = DateTime.fromISO(isoStr);

    const timeFormat = showSeconds ? DateTime.TIME_WITH_SECONDS : DateTime.TIME_SIMPLE;
    const time = timestamp.toLocaleString(timeFormat);
    let date;

    if (timestamp.toISODate() === DateTime.fromMillis(new Date().getTime()).toISODate()) {
        date = i18n.t('dt_today.text');
    } else if (
        timestamp.toISODate() === DateTime.fromMillis(new Date().getTime()).minus({days: 1}).toISODate()
    ) {
        date = i18n.t('dt_yesterday.text');
    } else {
        date = timestamp.toLocaleString(DateTime.DATE_MED);
    }

    return `${date} at ${time}`;
};

export default isoTimeToLocal;
